import { render, staticRenderFns } from "./specializations.vue?vue&type=template&id=23f1a35b&"
import script from "./specializations.vue?vue&type=script&lang=js&"
export * from "./specializations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports